export const NEEDS_ANALYSIS = 'Needs Analysis';
export const INCOME_REPLACEMENT = 'Income Replacement';
